/**
 * cl-filter-drawer.js — open/close controller for the collection filter drawer.
 * Responsibilities only: open (Filter button), close (✕ / overlay / ESC), focus trap,
 * focus return, scroll lock. No filtering logic (that's the Liquid form + URL params).
 *
 * The AJAX sort/filter/reset engine lives in cl-collection.js; after an apply it fires a
 * 'cl-filter-drawer:close' event on document so we close the drawer from here.
 */
(function () {
  function init() {
    var drawer = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;

    var overlay = document.querySelector('[data-filter-overlay]');
    var openBtns = document.querySelectorAll('[data-filter-open]');
    var closeEls = document.querySelectorAll('[data-filter-close]');
    var lastFocused = null;

    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

    function open() {
      lastFocused = document.activeElement;
      syncAccordion(); // match each group's expanded state to [open] while still hidden (no anim seen)
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      if (overlay) {
        overlay.hidden = false;
        void overlay.offsetWidth;
        overlay.classList.add('is-open');
      }
      document.documentElement.classList.add('ss-scroll-lock');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });

      // Focus the dialog container (tabindex="-1") rather than the close button — moves focus
      // into the modal for a11y without showing a focus ring on the X every open. Keyboard
      // users see the ring only once they Tab to a real control.
      drawer.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      document.documentElement.classList.remove('ss-scroll-lock');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key === 'Tab') trapFocus(e);
    }

    function trapFocus(e) {
      var nodes = drawer.querySelectorAll(FOCUSABLE);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      // We focus the drawer container itself on open (tabindex="-1"); it's not in `nodes`, so an
      // immediate Shift+Tab could escape. Snap focus to an edge instead.
      if (document.activeElement === drawer) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
        return;
      }
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    // --- Animated accordion (multi-open): JS orchestrates the <details> timing, CSS does the motion. ---
    drawer.classList.add('js-accordion');

    function syncAccordion() {
      var lists = drawer.querySelectorAll('.filter-list');
      for (var i = 0; i < lists.length; i++) {
        lists[i].classList.toggle('is-open', lists[i].open);
      }
    }

    // Delegated so it survives the filter form being swapped by cl-collection.js.
    drawer.addEventListener('click', function (e) {
      var summary = e.target.closest('summary.filter-list__header');
      if (!summary || !drawer.contains(summary)) return;
      e.preventDefault(); // take over the native instant toggle

      var details = summary.parentElement;
      var body = details.querySelector('.filter-list__body');

      if (details.open) {
        // Close: collapse, then drop [open] once the height transition finishes.
        details.classList.remove('is-open');
        var onEnd = function (ev) {
          if (ev.target !== body || ev.propertyName !== 'grid-template-rows') return;
          body.removeEventListener('transitionend', onEnd);
          if (!details.classList.contains('is-open')) details.open = false;
        };
        body.addEventListener('transitionend', onEnd);
      } else {
        // Open: render content first, expand on the next frame so the transition runs.
        details.open = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { details.classList.add('is-open'); });
        });
      }
    });

    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeEls.forEach(function (c) { c.addEventListener('click', close); });

    // Let the AJAX engine (cl-collection.js) close the drawer after an apply.
    document.addEventListener('cl-filter-drawer:close', close);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
